namespace $ {

	export class $shm_hitalama_map_history_storage_index extends $giper_baza_entity.with({
		Targets: $shm_hitalama_map_history_storage_targets,
		Commands: $giper_baza_dict_to( $giper_baza_atom_link ),
		Routing: $giper_baza_atom_bool,
	}) {}

}
